<template>
  <div class="text-center">
    <v-dialog
        v-model="modalCashout"
        v-on:close="toggleDialogCashout()"
        v-on:click:outside="toggleDialogCashout()"
        width="500"
    >
      <v-card>

        <v-card>
          <v-card-title>Cashout Confirmation</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="text-align: center">
            Transaksi selain ke bank BNI akan dikenakan biaya admin sebesar 6.500
          </v-card-text>
          <v-card-text style="">
            <v-select
                :items="rekeningCashout"
                label="Bank"
                v-model="destination"
            ></v-select>

            <v-text-field
                label="Nominal"
                :rules="rules"
                v-model="amount"
                hide-details="auto"
            ></v-text-field>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="grey darken-1"
                text
                v-on:click="toggleDialogCashout()"
            >
              Close
            </v-btn>
            <v-btn
                color="green darken-1"
                text
                v-on:click="doCashOut(destination, amount)"
            >
              Cashout
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Utils from "@/plugins/utils";
import moment from "moment";
// import VueClipboard from 'vue-clipboard2'
// import Vue from 'vue'

// VueClipboard.config.autoSetContainer = true // add this line

export default {
  name: "ModalCashout",
  data: ()=>({
    rules: [
      value => !!value || 'Required.',
      value => (value || '').length <= 20 || 'Max 20 characters',
    ],
    destination: "",
    amount: 0
  }),
  mounted() {
  this.getRekeningCashout({
    search:'',
    itemsPerPage: 100,
    page:1,
    sortBy: ["id"],
    awal: moment().add(7,'hours').toISOString().substr(0, 10),
    akhir: moment().add(7,'hours').toISOString().substr(0, 10),
  });
  },
  computed: {
    ...mapState('Bayartempo',['modalCashout','loadingCashout', 'rekeningCashout'])
  },
  methods: {
    ...mapActions('Bayartempo',['toggleDialogCashout', 'toggleLoadingCashout','getRekeningCashout','manualCashout']),
    formatAngka(val){
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
    },
    doCashOut (val, amount) {
      if(val != "" && amount != 0){
        const idbank = val.split(" ")[0].substring(1);
        this.manualCashout({id: idbank, amount})
      }else{
        alert("Rekening dan nominal tidak boleh kosong");
      }
    }
  }

}
</script>

<style scoped>

</style>